<template>
  <span>{{ value }}</span>
</template>

<script>
// this component is intentionnaly named `C`
// to reduce code size. And `k` property is for key

import { mapGetters } from 'vuex';

export default {
  props: {
    k: {
      type: String,
      default: '',
    },
    t: {
      type: String,
      default: '{}',
    },
  },
  computed: {
    ...mapGetters({ Contents: 'contents/Contents' }),


    value() {
      if (!this.Contents.hasOwnProperty(this.k)) {
        return `${this.$t('components.c.undefined')} ${this.k}`;
      }
      const { value } = this.Contents[this.k];

      return this.t.replace('{}', value);
    },
  },

};
</script>
